import { render, staticRenderFns } from "./ViewSupplierFailureCodeList.vue?vue&type=template&id=68697678&"
import script from "./ViewSupplierFailureCodeList.vue?vue&type=script&lang=js&"
export * from "./ViewSupplierFailureCodeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports